import {createSelector} from '@ngrx/store';

import {getAuthState} from '../state';
import {AuthState} from './reducer';

export const getAuthIsAuthenticated = createSelector(getAuthState, (state: AuthState) => state.isAuthenticated);

export const getAuthError = createSelector(getAuthState, (state: AuthState) => state.errorText);
